export function getDisplayPlanName(
  plan: string,
  subscriptionStatus?: string | null,
  email?: string | null
): string {
  if (plan === "agent") {
    if (email?.toLowerCase().endsWith("@zimamedia.com")) {
      return "Agent";
    }
    return "Agency";
  }
  if (plan === "pro") {
    if (subscriptionStatus === "trialing") return "Pro (Trial)";
    return "Pro";
  }
  if (plan === "starter") {
    return "Starter";
  }
  return plan.charAt(0).toUpperCase() + plan.slice(1);
}
